// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

const OBJECTTYPE_BOUND_STATE_VALUES = [
  'UNBOUND',
  'TRANSIENT',
  'BOUND_TO_WORKBOOK',
  'BOUND_TO_PROJECT',
] as const;

/** @see net/disy/cadenza/repository/api/objecttype/ObjecttypeBoundState.java */
export type ObjecttypeBoundState = (typeof OBJECTTYPE_BOUND_STATE_VALUES)[number];

export const ObjecttypeBoundState = {
  values: OBJECTTYPE_BOUND_STATE_VALUES as readonly ObjecttypeBoundState[],
} as const;

// </GENERATED-CODE>

export function isBoundToWorkbookOrTransient(boundState: ObjecttypeBoundState){
  return boundState === 'BOUND_TO_WORKBOOK' || boundState === 'TRANSIENT';
}